import React, { PureComponent, Fragment } from 'react';
import { Row, Col } from 'reactstrap';
import styled from 'styled-components';
import party from '../assets/footer-party.png';
import logo from '../assets/oakhouse-logo.png';

const Image = styled.img`
  margin-top: 6rem;
`;

const Logo = styled.img`
  max-height: 35px;
  margin-top: 1rem;
  margin-bottom: 1rem;
`;

class Footer extends PureComponent {
  getYear = () => (new Date()).getFullYear();

  render() {
    return (
      <Fragment>
        <Image src={party} alt="oakhouse matsuri" className="img-fluid" />
        <footer className="container">
          <Row>
            <Col md="12" className="d-flex flex-row justify-content-center">
              <Logo src={logo} className="img-fluid" />
            </Col>
          </Row>
          <Row>
            <Col md="12" className="d-flex flex-row justify-content-center">
              <p className="text-muted" style={{ textAlign: 'center' }}>
                Copyright {this.getYear()} © OAKHOUSE All Right Reserved.
              </p>
            </Col>
          </Row>
        </footer>
      </Fragment>
    );
  }
}

export default Footer;
